import {
  setNodes,
  setRootNodes,
  setTreeNodes,
  clearTree,
  toggleExpanded,
  setLoading
} from './actions'
import { getUid, getQueryResults } from 'Services/WeaverUtils'

squashRelations = (node, relationsToFollow) ->
  { toInclude, toIgnore } = relationsToFollow
  getRelationsOut = (node, key) -> node.relation(key)
  getRelationOutKeys = (node) -> _.keys(node.relations())

  getRelationsIn = (node, key) -> node.relationsIn[key]
  getRelationInKeys = (node) -> _.keys(node.relationsIn)

  # Filter out toIgnore
  if toInclude.find((rel) -> rel.key is '*')
    relKeys = getRelationOutKeys(node)
      .map((key) -> { key, orientation: 'OUT' })
      .concat(
        getRelationInKeys(node)
          .map((key) -> { key, orientation: 'IN' })
      )

  else
    relKeys = toInclude

  filtered = _.differenceWith(relKeys, toIgnore, _.isEqual)

  allRels = filtered.map(({ key, orientation }) ->
      if orientation is 'OUT'
        getRelationsOut(node, key)?.all() or []
      else
        getRelationsIn(node, key)?.all() or []
    ).flat()

  _.uniqBy(allRels, getUid)

buildChildMap = (nodes, relationsToFollow, parent) ->
  nodes.reduce((acc, node) ->
    acc[getUid(node)] = squashRelations(node, relationsToFollow).map(getUid)
    acc
  , {})

# Dispatches state updates to `treeData`, and `nodeData`
updateNodes = (nodes, childMap, dispatch) ->
  if nodes.length is 400
    nodes.push({
      id: () -> 'isLimited',
      isLimited: true
    })
    childMap.isLimited = []
  dispatch(setNodes(nodes))
  dispatch(setTreeNodes(childMap))

export loadRootTreeNodes = (query, relationsToFollow =  {toInclude: [], toIgnore: [], toExclude: []}, dispatch) ->
  dispatch(setLoading(true))
  dispatch(clearTree())
  nodes = await getQueryResults(query)
  childMap = buildChildMap(nodes, relationsToFollow, parent)
  updateNodes(nodes, childMap, dispatch)
  dispatch(setRootNodes(nodes.map(getUid)))
  dispatch(setLoading(false))

getDirectIncomings = (node, relationsToFollow) ->
  keys = relationsToFollow.toInclude
    .filter(({ orientation, key }) -> orientation is 'IN')
    .map(({ key }) -> key)
  allDirectIns = []
  if '*' in keys
    for key, v of node.relationsIn
      allDirectIns.push(v.all())
  else
    allDirectIns = keys.map((key) ->
      node.relationsIn[key]?.all()
    )
  _.uniq(allDirectIns.flat().filter((rec) -> rec?).map(getUid))

loadChildren = ({ node, relationsToFollow, dispatch }) ->
  applySelector = (q, { key, orientation }) ->
    if orientation is 'OUT'
      q.selectOut(key)
    else if orientation is 'IN'
      q.selectIn(key, key)
    q

  applyMinusSelector = (q, { key, orientation }) ->
    if orientation is 'OUT'
      q.selectOutMinus(key)
    else if orientation is 'IN'
      q.selectInMinus(key)
    q

  applyExcludeSelector = (q, { key, target }) ->
    q.excludeNodesWith(key, target)
    q

  query = new Weaver.Query()
    .restrict([node.id()])
    .inGraph(node.graph)
    .selectInOnLoad()

  applySelector(query, rel) for rel in relationsToFollow.toInclude
  applyMinusSelector(query, rel) for rel in relationsToFollow.toIgnore
  applyExcludeSelector(query, condition) for condition in relationsToFollow.toExclude

  loaded = await query.first()
  relations = await squashRelations(loaded, relationsToFollow)
  childMap = buildChildMap(relations, relationsToFollow)
  incomings = getDirectIncomings(loaded, relationsToFollow)

  updateNodes(relations, { childMap..., [getUid(node)]: incomings }, dispatch)

export onExpandNode = ({ node, key, relationsToFollow, orientation, isExpanded, dispatch }) ->
  dispatch(toggleExpanded(key, isExpanded))
  loadChildren({ node, relationsToFollow, dispatch })
